module.exports = __webpack_public_path__ + "img/attractiveness.ac66d96f.webp";